/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["nz-sider[_ngcontent-%COMP%]{box-shadow:0 2px 4px rgba(0,0,0,.1)}.inbox-main[_ngcontent-%COMP%]{height:100%;display:flex;padding:10px 5px}.left[_ngcontent-%COMP%]{width:560px;padding-left:5px;padding-right:5px}.right[_ngcontent-%COMP%]{width:100%;height:100%;padding-left:5px;padding-right:5px}[_nghost-%COMP%]     .ant-card-body{padding:10px}.actions-container[_ngcontent-%COMP%]{display:flex;justify-content:center;margin-top:20px}"];
export { styles as styles };
